import styled from "styled-components";

export const CategoriasStyle = styled.div`
    
`;